export default __webpack_public_path__ + "static/media/wSweats_1_p2.9d6c6e8c.jpeg";